import api from "./axios-setup/axios";

/**
 * Set Organization Behavior
 * @param {string} organizationId - Organization id
 * @param {string} behavior - Primary behavior description
 * @param {string} [additionalInstructions] - extra instructions
 * @returns {Promise<object>} Api response
 */
export const setOrganizationBehavior = async (
  organizationId,
  behavior,
  additionalInstructions,
) => {
  const response = await api.post(`/organizations/${organizationId}/behavior`, {
    behavior,
    additional_instructions: additionalInstructions,
  });

  return response.data;
};

/**
 * Get Organization Behavior
 * @param {string} organizationId - Organization id
 * @returns {Promise<object>} result
 */
export const getOrganizationBehavior = async (organizationId) => {
  const response = await api.get(`/organizations/${organizationId}/behavior`);

  return response.data;
};

/**
 *Clear Organization Behavior
 * @param {string} organizationId - Organization id
 * @returns {Promise<object>} Api response
 */
export const clearOrganizationBehavior = async (organizationId) => {
  const response = await api.delete(
    `/organizations/${organizationId}/behavior`,
  );

  return response.data;
};

/**
 * Update Organization Behavior (PUT)
 * @param {string} organizationId - Organization id
 * @param {object} payload - Behavior payload
 * @returns {Promise<object>} Api response
 */
export const updateOrganizationBehavior = async (organizationId, payload) => {
  const safePayload = {
    behavior: payload?.behavior || "",
    additional_instructions: payload?.additional_instructions || "",
  };

  const response = await api.put(
    `/organizations/${organizationId}/behavior`,
    safePayload,
  );

  return response.data;
};

/**
 * Update Organization Behavior Meta Data (PUT)
 * @param {string} organizationId - Organization id
 * @param {object} metaData - behavior meta_data payload
 * @returns {Promise<object>} Api response
 */
export const updateOrganizationBehaviorMetaData = async (
  organizationId,
  metaData,
) => {
  try {
    const response = await api.put(
      `/organizations/${organizationId}/behavior/meta-data`,
      { meta_data: metaData },
    );
    return response.data;
  } catch (error) {
    // Fallback for APIs that expect raw object instead of wrapped meta_data key.
    if (error?.response?.status === 422 || error?.response?.status === 400) {
      const fallbackResponse = await api.put(
        `/organizations/${organizationId}/behavior/meta-data`,
        metaData,
      );
      return fallbackResponse.data;
    }
    throw error;
  }
};
